import { StytchB2BProvider } from "@stytch/react/b2b";
import { StytchB2BUIClient } from "@stytch/vanilla-js/b2b";
import type { ReactNode } from "react";

// Lazy initialization to avoid calling env vars during SSR
let stytch_client: StytchB2BUIClient | null = null;

/**
 * Get the Stytch client instance.
 * Returns null during SSR.
 */
export function get_stytch_client(): StytchB2BUIClient | null {
  if (!stytch_client && typeof window !== "undefined") {
    const is_production = window.location.hostname.endsWith("orchestraight.com");
    stytch_client = new StytchB2BUIClient(
      import.meta.env.VITE_STYTCH_PUBLIC_TOKEN,
      is_production ? { cookieOptions: { domain: ".orchestraight.com" } } : undefined
    );
  }
  return stytch_client;
}

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const client = get_stytch_client();

  // During SSR, render children without provider
  if (!client) {
    return <>{children}</>;
  }

  return <StytchB2BProvider stytch={client}>{children}</StytchB2BProvider>;
}
